import cut from './cut'

const install = function(Vue) {
  Vue.directive('cut', cut)
}

if (window.Vue) {
  window.cut = cut
  Vue.use(install); // eslint-disable-line
}

cut.install = install
export default cut
